import React from 'react';
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
// Tailwind migration: inline classes

const Footer = ({ language }) => {
  const locale = language === 'pt' ? 'pt' : 'en';

  return (
    <footer className="mt-16 border-t border-border bg-foreground/[0.02]">
      <div className="container py-10">
        <div className="flex flex-col md:flex-row gap-8 md:gap-4 justify-between">
          <div className="space-y-2">
            <h3 className="text-lg font-semibold">Matheus Pereira Gonsalves</h3>
            <p className="max-w-md text-sm text-muted-foreground">{locale === 'pt' ? 'Engenheiro de Software com foco em solucoes inovadoras, escalaveis e de alta performance.' : 'Software Engineer with a passion for creating innovative, scalable, and high-performance solutions.'}</p>
          </div>

          <div>
            <h3 className="text-lg font-semibold">{locale === 'pt' ? 'Links' : 'Links'}</h3>
            <ul className="mt-3 space-y-2 text-sm">
              <li><a className="hover:text-primary transition-colors" href="#about">{locale === 'pt' ? 'Sobre' : 'About'}</a></li>
              <li><a className="hover:text-primary transition-colors" href="#experience">{locale === 'pt' ? 'Experiencia' : 'Experience'}</a></li>
              <li><a className="hover:text-primary transition-colors" href="#projects">{locale === 'pt' ? 'Projetos' : 'Projects'}</a></li>
              <li><a className="hover:text-primary transition-colors" href="#skills">{locale === 'pt' ? 'Skills' : 'Skills'}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold">{locale === 'pt' ? 'Conectar' : 'Connect'}</h3>
            <ul className="mt-3 flex items-center gap-4">
              <li>
                <a className="hover:text-primary transition-colors" href="https://www.linkedin.com/in/matheuspereiragonsalves/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <FaLinkedin size={20} />
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="https://github.com/Matheuspgonsalves" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                  <FaGithub size={20} />
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="mailto:matheuspereiragonsalvespj@gmail.com" aria-label="Email">
                  <FaEnvelope size={20} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-border pt-4 text-center text-xs text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Matheus Pereira Gonsalves. {locale === 'pt' ? 'Todos os direitos reservados.' : 'All rights reserved.'}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
